<template>
  <div style="padding:10px;background-color: #F5F5F5;min-height: 100%">

    <Card  :bordered="false" :dis-hover="true" style="margin-bottom:10px;">
      <div style="text-align:left">
        <Row>
          <Col span="19">
            <Button type="primary" @click="modal1=true">+增加线下课程</Button>
            <cite>|</cite>
            线下课程管理
          </Col>
          <Col span="5">
             <Input search enter-button placeholder="输入课程名称搜索" v-model="serch.key"  @on-search="load"/>
          </Col>
        </Row>
      </div>
    </Card>

    <Card :dis-hover="true">
      <Spin fix v-if="loading"></Spin>
      <el-table :data="list" size="small" style="width: 100%" >
        <el-table-column prop="img" label="课程封面图" :show-tooltip-when-overflow="true" width="90">
          <template slot-scope="scope">
            <img :src="'/api/upload/online/'+scope.row.img" style="width:80px;"/>
          </template>
        </el-table-column>
        <el-table-column prop="productName" label="课程名称" :show-tooltip-when-overflow="true">
          <template slot-scope="scope">
            <a @click="modal2=true;productId=scope.row.id">{{scope.row.productName}}</a>
          </template>
        </el-table-column>
        <el-table-column prop="categoryName" label="分类" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="count" label="课程场次" width="90" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="ctime" label="创建时间" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="msg" label="操作" width="120" fixed="right">
          <template slot-scope="scope">
            <a @click="edit(scope.row.id)">编辑</a>
            <cite>|</cite>
            <Poptip
              confirm
              :transfer="true"
              title="确定要删除吗（删除后不可恢复）"
              @on-ok="remove(scope.row.id)"
              ok-text="确定"
              placement="top-end"
              cancel-text="取消">
              <a @click="">删除</a>
            </Poptip>

          </template>
        </el-table-column>
      </el-table>
    </Card>

    <Card  :bordered="false" dis-hover style="text-align: center;margin-top:10px">
      <Page :total="count" show-total :page="page" @on-page-size-change="limitChange"  show-elevator @on-change="change"  show-sizer :page-size-opts="[10, 30,50,100]"></Page>
    </Card>

    <Modal
      v-model="modal1"
      title="增加或编辑"
      width="70%"
      :mask-closable="false"
      @on-ok="save">
      <Form :label-width="100">
				<FormItem label="课程名称" required>
					<Input v-model="detail.productName"/>
				</FormItem>
				<FormItem label="分类" required>
          <FieldClassify v-model="detail.categoryId" type="线下课"></FieldClassify>
				</FormItem>
				<FormItem label="课程封面图" required>
          <UploadOne  v-model="detail.img"></UploadOne>
          <font color="red">大小：960*480 像素（2:1），50kb以内</font>
				</FormItem>
				<FormItem label="课程大纲" required>
          <Input v-model="detail.outLineText" type="textarea" style="font-size: 15px;" :autosize="{minRows: 6,maxRows: 50}" placeholder="课程大纲"></Input>
          <p>
           <a href="https://www.yuque.com/docs/share/31345305-d849-47d9-b1bc-39c6b8a13fe0" target="_blank">请点击查看说明</a>
          </p>
          <!--<JsonEdit :detail="detail.jsonObj" v-model="detail.outLine" type="课程大纲"></JsonEdit>-->
				</FormItem>
				<FormItem label="课程介绍" required>
          <Input v-model="detail.description" type="textarea" style="font-size: 15px;" :autosize="{minRows: 6,maxRows: 50}" placeholder="课程介绍"></Input>
          <!--<JsonEdit :detail="detail.descObj" v-model="detail.description" type="课程介绍"></JsonEdit>-->
          <p>
            <a href="https://www.yuque.com/docs/share/31345305-d849-47d9-b1bc-39c6b8a13fe0" target="_blank">请点击查看说明</a>
          </p>
        </FormItem>
      </Form>

      <div slot="footer">
        <Button @click="modal1=false;">取消</Button>
        <Button type="primary" @click="save" :loading="loading">保存</Button>
      </div>
    </Modal>

    <Drawer title="课程场次管理"  width="70%" v-model="modal2">
      <ProductDetail :productId="productId"></ProductDetail>
    </Drawer>

  </div>
</template>

<script>

  import JsonEdit from '@/components/common/json/JsonEdit'
  import UploadOne from '@/public/upload/UploadOne'
  import FieldClassify from '@/components/common/field/FieldClassify.vue'
  import ProductDetail from './ProductDetail'
  export default {
    components:{UploadOne,FieldClassify,ProductDetail,JsonEdit},
    data(){
      return{
        baseUrl:'/api/product/product/',
        list:[],
        page:1,
        count:0,
        limit:10,
        modal1:false,
        detail:{},
        serch:{
          key:''
        },
        loading:false,
        modal2:false,
        productId:0,
        loading:false,
      }
    },
    methods:{
      load(){
        let that = this;
        let params = [];
        if(this.serch.key){
          params.push('t.productName@like@'+this.serch.key);
        }
        params.push('t.productType@like@线下课');
        that.loading = true;
        this.$axios.get(this.baseUrl+'findall?page='+this.page+'&limit='+this.limit+'&params='+params).then(function(rs){
          that.list = rs.data.data;
          that.count = rs.data.count;
          that.loading = false;
        });
      },
      limitChange(val){
        this.limit = val;
        this.load();
      },
      change(val){
        this.page = val;
        this.load();
      },
      save(){
        let that = this;
        this.detail.productType = '线下课';
        this.detail.jsonObj = null;
        this.detail.descObj = null;

        let data = Object.assign({}, this.detail);
        this.loading = true;
        this.$axios({url:this.baseUrl+'save',method:'post',data:this.$qs.stringify(data)}).then(function(rs){
          that.toast(rs.data);
          if(rs.data.success){
            that.detail = {};
            that.modal1 = false;
          }
          that.loading = false;
        });
      },
      edit(id){
        let that = this;
        this.$axios.get(this.baseUrl+'getById?id='+id).then(function(rs){
          that.detail = rs.data;
          that.modal1 = true;
        });
      },
      remove(id){
        let that = this;
        this.$axios.get(this.baseUrl+'delete?ids='+id).then(function(rs){
          that.toast(rs.data);
        });
      },
      toast(data){
        if(data.success){
          this.load();
          this.$Message.success(data.msg);
        }else{
          this.$Message.error({
            content: data.msg,
            duration: 8,
            closable: true
          });
        }
      }
    },
    created(){
      this.load();
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/product/Product.vue